/** Shared airport options for hero + flights search (IATA dropdowns) */
export const FLIGHT_AIRPORTS = [
  { code: 'ISB', label: 'Islamabad (ISB)', city: 'Islamabad' },
  { code: 'LHE', label: 'Lahore (LHE)', city: 'Lahore' },
  { code: 'KHI', label: 'Karachi (KHI)', city: 'Karachi' },
  { code: 'PEW', label: 'Peshawar (PEW)', city: 'Peshawar' },
  { code: 'LYP', label: 'Faisalabad (LYP)', city: 'Faisalabad' },
  { code: 'MUX', label: 'Multan (MUX)', city: 'Multan' },
  { code: 'SKT', label: 'Sialkot (SKT)', city: 'Sialkot' },
  { code: 'UET', label: 'Quetta (UET)', city: 'Quetta' },
  { code: 'JED', label: 'Jeddah / Makkah (JED)', city: 'Makkah' },
  { code: 'MED', label: 'Madinah (MED)', city: 'Madinah' },
  { code: 'RUH', label: 'Riyadh (RUH)', city: 'Riyadh' },
  { code: 'DXB', label: 'Dubai (DXB)', city: 'Dubai' },
  { code: 'AUH', label: 'Abu Dhabi (AUH)', city: 'Abu Dhabi' },
  { code: 'SHJ', label: 'Sharjah (SHJ)', city: 'Sharjah' },
  { code: 'IST', label: 'Istanbul (IST)', city: 'Istanbul' },
  { code: 'SAW', label: 'Sabiha Gökçen — Istanbul (SAW)', city: 'Istanbul (Sabiha)' },
  { code: 'AYT', label: 'Antalya (AYT)', city: 'Antalya' },
  { code: 'LHR', label: 'London Heathrow (LHR)', city: 'London' },
  { code: 'MAN', label: 'Manchester (MAN)', city: 'Manchester' },
  { code: 'JFK', label: 'New York JFK (JFK)', city: 'New York' },
  { code: 'DOH', label: 'Doha (DOH)', city: 'Doha' },
  { code: 'BAH', label: 'Bahrain (BAH)', city: 'Bahrain' },
  { code: 'MCT', label: 'Muscat (MCT)', city: 'Muscat' },
  { code: 'KUL', label: 'Kuala Lumpur (KUL)', city: 'Kuala Lumpur' },
];

export const getAirportLabel = (code) =>
  FLIGHT_AIRPORTS.find((a) => a.code === code)?.label || code;
